import {makeStyles} from '@material-ui/core/styles'
import {colors} from '../../../shared/colors'

function getBackgroundColor(severity){
    if(severity === 'error'){
        return colors.magellanRed
    }
    else if(severity === 'success'){
        return colors.californiaGreen
    }
}

function getColor(){
    return colors.magellanWhite
}

const useStyles = makeStyles({
    button: props => ({
        backgroundColor: getBackgroundColor(props.severity),
        color: getColor(),
        padding: '1rem',
        margin: '0.3rem',
        '&:hover':{
            backgroundColor: getBackgroundColor(props.severity),
        }
    }),
    message: {
        fontWeight: 'bold',
        padding: '0.3rem',
        textTransform: 'none'
    },
})

export default useStyles